import { Constants } from "hhn-commons";

export function storeOrganizationId(orgId: string): void {
  try {
    localStorage.setItem(Constants.ORG_ID_KEY, orgId);
  } catch (error) {
    console.error("Error saving organization ID:", error);
    throw error;
  }
}

export function loadOrganizationId(): string | null {
  try {
    return localStorage.getItem(Constants.ORG_ID_KEY);
  } catch (error) {
    console.error("Error retrieving organization ID:", error);
    return null;
  }
}

export function clearOrganizationId(): void {
  try {
    localStorage.removeItem(Constants.ORG_ID_KEY);
  } catch (error) {
    console.error("Error removing organization ID:", error);
    throw error;
  }
}

export const organizationIdStorage = {
  storeOrganizationId,
  loadOrganizationId,
  clearOrganizationId,
};
